import { useTranslatedStaticPage } from '@/hooks';

export default function DataRemoveFormView() {
  const { content } = useTranslatedStaticPage('data-remove-form');

  return (
    <div
      className='typography max-w-7xl xl:px-12 mx-auto h-full pb-48'
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}
